<div class="container-fluid compare-sec">
  <div class="row breadcrumb-wrapper">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <div class="container">
        <div class="d-block d-md-flex my-3 my-lg-4">
          <h1 class="page-sub-title cv-text-dark mb-3 mb-md-0">Compare the Variants</h1>
          <nav class="ms-auto bg-light-gray">
            <div class="nav nav-pills" id="pills-tab" role="tablist">
              <button class="nav-link" [ngClass]="lobName == 'icv trucks' ? 'active' : ''" id="pills-home-tab"
                data-bs-toggle="tab" data-bs-target="#pills-home" type="button" role="tab" aria-controls="nav-home"
                aria-selected="true" (click)="changeTab('Icv Trucks')">Trucks</button>
                <button class="nav-link" [ngClass]="lobName == 'buses' ? 'active' : ''" id="pills-profile-tab"
                data-bs-toggle="tab" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-profile"
                aria-selected="false" (click)="changeTab('Buses')">Buses & Vans</button>
              <button class="nav-link" [ngClass]="lobName == 'scv pickups' ? 'active' : ''" id="pills-home-tab"
                data-bs-toggle="tab" data-bs-target="#pills-home" type="button" role="tab" aria-controls="nav-home"
                aria-selected="true" (click)="changeTab('Scv Pickups')">SCV & Pickups</button>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <div class="tab-content" id="pills-tabContent">
    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
      <div class="compare-item-main scroll-fix">
        <div class="container">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-2 border-end border-dashed bw-2 pt-4 pb-4 smilar-sec">
                  <div class="smilar-how smilar-how d-flex flex-column ps-3 justify-content-end h-100">
                    <h2 class="page-sub-title cv-text-dark scroll-fix-title">Compare</h2>
                    <!-- do not remove -->
                    <!-- <div class="form-check mt-4">
                      <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                      <label class="form-check-label" for="flexCheckDefault">
                        Show Similarities
                      </label>
                    </div> -->
                  </div>

                </div>
                <div class="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-10 comp-sel pt-5 pb-4">
                  <div class="row g-md-4 g-lg-5">
                    <div class="col-4 col-sm-4 col-md-4">
                      <div class="form mobile-view" *ngIf="!showDesignOne">
                        <div class="icon-img">
                          <img [src]='environment1 + "assets/images/compare-ic.png"' class="img-fluid" alt="compare-ic" (click)="toggleMobileForm(1)" loading="lazy">
                          <div class="icon-text d-none" (click)="toggleMobileForm(1)">Add Truck</div>
                        </div>
                        <div class="mobile-view-form" [ngClass]="{'active': isMobileFormVisible}">
                          <div class="mb-heading d-md-none">
                            <h6>Add Truck</h6>
                            <a (click)="toggleMobileForm(1)">Close</a>
                          </div>
                          <div class="form-group mb-3 position-relative">
                             <select class="form-select" name="select-v" [(ngModel)]="selectedAccountOne"
                              (change)="getItemOne($event)">
                              <option value="" selected>Select PPL</option>
                              <optgroup label="{{ group.name }}" *ngFor="let group of DataOneArray">
                                <option value="{{ grp.pl }}" *ngFor="let grp of group.values">
                                  {{ grp.pl }}
                                </option>
                              </optgroup>
                            </select>
                          </div>
                          <div class="form-group mb-3">
                            <select class="form-select" name="select-v" (change)="getTruckBusOne()"
                              [(ngModel)]="selectedTruckBusOne">
                              <option value="" selected>Select Model</option>
                              <option *ngFor="let model of modelDataOne" value="{{ model.id }}">
                                {{ model.product_description | titlecase }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="compare-item" *ngIf="productDetailsDataOne">
                        <a class="comp-close" (click)="reset('One')"><img [src]='environment1 + "assets/images/close-icon.svg"' alt="close-icon"
                            class="img-fluid cursor-pointer" alt="close-icon" loading="lazy"/></a>
                        <div class="compare-img">

                          <img *ngIf="productDetailsDataOne?.images[0]?.image_url" src="{{ productDetailsDataOne?.images[0]?.image_url }}"  width="178px"
                          height="115px" class="img-fluid" alt="{{ productDetailsDataOne?.model }}" loading="lazy">
                          <img *ngIf="!productDetailsDataOne?.images[0]?.image_url" [src]='environment1 + "assets/images/default_vehicle_img.webp"'  width="178px"
                          height="115px" class="img-fluid" alt="{{ productDetailsDataOne?.model }}" loading="lazy">

                        </div>
                        <div class="compare-content">
                          <p>{{ productDetailsDataOne?.model }}</p>
                          <h5><span *ngIf="productDetailsDataOne?.price_range">
                              {{ productDetailsDataOne?.price_range ?
                              (productDetailsDataOne?.price_range
                              |currency:'INR':'symbol':'4.0-0') : "₹" }}</span>
                            <span *ngIf="!productDetailsDataOne?.price_range">Please contact to Dealer.</span></h5>
                        </div>

                        <button type="button" class="btn btn-outline-primary w-100" (click)="bookNow(productDetailsDataOne)" data-toggle="tooltip" data-placement="top" title="Click here for Booking">Book Now At {{ ((productDetailsDataOne?.down_payment | currency:'INR':'symbol':'4.0-0')) }}</button>                      </div>
                    </div>
                    <div class="col-4 col-sm-4 col-md-4">
                      <div class="form mobile-view" *ngIf="!showDesignTwo">
                        <div class="icon-img">
                          <img [src]='environment1 + "assets/images/compare-ic.png"' class="img-fluid" alt="compare-ic" (click)="toggleMobileForm(2)" loading="lazy">
                          <div class="icon-text d-none"  (click)="toggleMobileForm(2)" >Add Truck</div>
                        </div>
                        <div class="mobile-view-form" [ngClass]="{'active': isMobileFormVisible2}">
                          <div class="mb-heading d-md-none">
                            <h6>Add Truck</h6>
                            <a (click)="toggleMobileForm(2)">Close</a>
                          </div>
                          <div class="form-group mb-3 position-relative">
                            <select class="form-select" name="select-v" (focus)="generateTwoArray()" [(ngModel)]="selectedAccountTwo"
                              (change)="getItemTwo($event)" [disabled]="!productDetailsDataOne">
                              <option value="" selected>Select PPL</option>
                              <ng-container *ngFor="let group of DataTwoArray">
                                <optgroup label="{{ group.name }}" *ngIf="group.values?.length > 0">
                                  <option value="{{ grp.pl }}" *ngFor="let grp of group.values">
                                    {{ grp.pl }}
                                  </option>
                                </optgroup>
                              </ng-container>
                            </select>
                          </div>
                          <div class="form-group mb-3">
                            <select class="form-select" name="select-v" (change)="getTruckBusTwo()"
                              [(ngModel)]="selectedTruckBusTwo" [disabled]="!productDetailsDataOne">
                              <option value="" selected>Select Model</option>
                              <option *ngFor="let model of modelDataTwo" value="{{ model.id }}">
                                {{ model.product_description | titlecase }}
                              </option>
                            </select>
                          </div>
                        </div>

                      </div>
                      <div class="compare-item" *ngIf="productDetailsDataTwo">
                        <a class="comp-close" (click)="reset('Two')"><img [src]='environment1 + "assets/images/close-icon.svg"' alt="close-icon"
                            class="img-fluid cursor-pointer" alt="close-icon" loading="lazy"/></a>
                        <div class="compare-img">
                            <img *ngIf="productDetailsDataTwo?.images[0]?.image_url" src="{{ productDetailsDataTwo?.images[0]?.image_url }}"  width="178px"
                            height="115px" class="img-fluid" alt="{{ productDetailsDataTwo?.model }}" loading="lazy">
                            <img *ngIf="!productDetailsDataTwo?.images[0]?.image_url" [src]='environment1 + "assets/images/default_vehicle_img.webp"'  width="178px"
                            height="115px" class="img-fluid" alt="{{ productDetailsDataTwo?.model }}" loading="lazy">

                        </div>
                        <div class="compare-content">
                          <p>{{ productDetailsDataTwo?.model }}</p>
                          <h5><span *ngIf="productDetailsDataTwo.price_range">
                              {{ productDetailsDataTwo?.price_range ?
                              (productDetailsDataTwo?.price_range
                              |currency:'INR':'symbol':'4.0-0') : "₹" }}</span>
                              <span *ngIf="!productDetailsDataTwo?.price_range">Please contact to Dealer.</span></h5>
                        </div>
                        <button type="button" class="btn btn-outline-primary w-100" (click)="bookNow(productDetailsDataTwo)" data-toggle="tooltip" data-placement="top" title="Click here for Booking">Book Now At {{ ((productDetailsDataTwo?.down_payment | currency:'INR':'symbol':'4.0-0')) }}</button>                      </div>
                    </div>
                    <div class="col-4 col-sm-4 col-md-4">
                      <div class="form mobile-view" *ngIf="!showDesignThree">
                        <div class="icon-img">
                          <img [src]='environment1 + "assets/images/compare-ic.png"' class="img-fluid" alt="compare-ic" (click)="toggleMobileForm(3)" loading="lazy">
                          <div class="icon-text d-none" (click)="toggleMobileForm(3)">Add Truck</div>
                        </div>
                        <div class="mobile-view-form" [ngClass]="{'active': isMobileFormVisible3}">
                          <div class="mb-heading d-md-none">
                            <h6>Add Truck</h6>
                            <a (click)="toggleMobileForm(3)">Close</a>
                          </div>
                          <div class="form-group mb-3 position-relative">
                            <select class="form-select" name="select-v" [(ngModel)]="selectedAccountThree" (focus)="generateThreeArray()"
                              (change)="getItemThree($event)" [disabled]="!productDetailsDataTwo">
                              <option value="" selected>Select PPL</option>
                              <ng-container  *ngFor="let group of DataThreeArray">
                                <optgroup label="{{ group.name }}" *ngIf="group.values?.length > 0">
                                  <option value="{{ grp.pl }}" *ngFor="let grp of group.values">
                                    {{ grp.pl }}
                                  </option>
                                </optgroup>
                              </ng-container>
                            </select>
                          </div>
                          <div class="form-group mb-3">
                            <select class="form-select" name="select-v" (change)="getTruckBusThree()"
                              [(ngModel)]="selectedTruckBusThree" [disabled]="!productDetailsDataTwo">
                              <option value="" selected>Select Model</option>
                              <option *ngFor="let model of modelDataThree" value="{{ model.id }}">
                                {{ model.product_description | titlecase }}
                              </option>
                            </select>
                          </div>
                        </div>

                      </div>
                      <div class="compare-item" *ngIf="productDetailsDataThree">
                        <a class="comp-close" (click)="reset('Three')"><img [src]='environment1 + "assets/images/close-icon.svg"' alt="close-icon"
                            class="img-fluid cursor-pointer" alt="close-icon" loading="lazy"/></a>
                        <div class="compare-img">
                            <img *ngIf="productDetailsDataThree?.images[0]?.image_url" src="{{ productDetailsDataThree?.images[0]?.image_url }}"  width="178px"
                            height="115px" class="img-fluid" alt="{{ productDetailsDataThree?.model }}" loading="lazy">
                            <img *ngIf="!productDetailsDataThree?.images[0]?.image_url" [src]='environment1 + "assets/images/default_vehicle_img.webp"'  width="178px"
                            height="115px" class="img-fluid" alt="{{ productDetailsDataThree?.model }}" loading="lazy">

                        </div>
                        <div class="compare-content">
                          <p>{{ productDetailsDataThree?.model }}</p>
                          <h5><span *ngIf="productDetailsDataThree?.price_range">
                              {{ productDetailsDataThree?.price_range ?
                              (productDetailsDataThree?.price_range
                              |currency:'INR':'symbol':'4.0-0') : "₹" }}</span>
                              <span *ngIf="!productDetailsDataThree?.price_range">Please contact to Dealer.</span></h5>
                        </div>
                        <button type="button" class="btn btn-outline-primary w-100" (click)="bookNow(productDetailsDataThree)" data-toggle="tooltip" data-placement="top" title="Click here for Booking">Book Now At {{ ((productDetailsDataThree?.down_payment | currency:'INR':'symbol':'4.0-0')) }}</button>                      </div>

                    </div>
                    <div class="d-grid d-md-none text-center compare-cta">
                      <button type="button" class="btn btn-primary btn-grad-primary btn-compare btn-disabled" data-toggle="tooltip" data-placement="top" title="Click here for Campare-product"
                                              disabled>Compare Now</button>
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>

        </div>
      </div>

      <div class="acordian-sec pt-5 pb-5">
        <div class="container">
          <div class="accordion" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                  aria-expanded="true" aria-controls="collapseOne">
                  <img [src]='environment1 + "assets/images/truck.png"' alt ="truck.png" class="img-fluid" loading="lazy"/> Vehicle Information
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <table class="table">
                    <tbody>
                      <tr>
                        <td>Vc Description</td>
                        <td>
                          {{
                          performanceOne && performanceOne.product_description
                          ? performanceOne.product_description
                          : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceTwo && performanceTwo.product_description
                          ? performanceTwo.product_description
                          : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.product_description
                          ? performanceThree.product_description
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Price Range</td>
                        <td>
                          {{ performanceOne && performanceOne.price_range ? (performanceOne.price_range
                          |currency:'INR':'symbol':'4.0-0') : "-" }}
                        </td>
                        <td>
                          {{ performanceTwo && performanceTwo.price_range ? (performanceTwo.price_range
                          |currency:'INR':'symbol':'4.0-0'): "-" }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.price_range ? (performanceThree.price_range
                          |currency:'INR':'symbol':'4.0-0'): "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Steering Type</td>
                        <td>
                          {{
                          performanceOne && performanceOne.steering_type ? performanceOne.steering_type : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceTwo && performanceTwo.steering_type ? performanceTwo.steering_type : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.steering_type
                          ? performanceThree.steering_type
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Product Category</td>
                        <td>
                          {{
                          performanceOne && performanceOne.product_category
                          ? performanceOne.product_category
                          : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceTwo && performanceTwo.product_category
                          ? performanceTwo.product_category
                          : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.product_category
                          ? performanceThree.product_category
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Product Type</td>
                        <td>
                          {{ performanceOne && performanceOne.product_type ? performanceOne.product_type : "-" }}
                        </td>
                        <td>
                          {{ performanceTwo && performanceTwo.product_type ? performanceTwo.product_type : "-" }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.product_type
                          ? performanceThree.product_type
                          : "-"
                          }}
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  <img [src]='environment1 + "assets/images/speedometer-power.png"' alt="speedometer-power" class="img-fluid" loading="lazy"/>
                  Performance
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <table class="table">
                    <tbody>
                      <tr>
                        <td
                        *ngIf="(!performanceOne && !performanceTwo && !performanceThree)">
                        Max Power</td>
                          <td
                          *ngIf="(performanceOne || performanceTwo || performanceThree) && (performanceOne.fuel_type == 'EV' || performanceTwo?.fuel_type == 'EV' || performanceThree?.fuel_type == 'EV' || performanceOne?.fuel_type == 'Electric' || performanceTwo?.fuel_type == 'Electric' || performanceThree?.fuel_type == 'Electric')">
                          Max Power / Max Motor Power</td>
                          <td
                          *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && !performanceTwo && !performanceThree)">
                          Max Power</td>
                          <td
                          *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo && performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && !performanceThree">
                          Max Power</td>

                        <td
                          *ngIf="((performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && performanceThree && (performanceThree?.fuel_type != 'EV' && performanceThree?.fuel_type != 'Electric')">
                          Max Power</td>

                        <td *ngIf="performanceOne?.fuel_type == 'EV' || performanceOne?.fuel_type == 'Electric'">
                          {{ performanceOne && performanceOne.max_motor_power ? performanceOne.max_motor_power : "-" }}
                        </td>
                        <td *ngIf="performanceOne?.fuel_type != 'EV' &&  performanceOne?.fuel_type != 'Electric'">
                          {{ performanceOne && performanceOne.max_power ? performanceOne.max_power : "-" }}
                        </td>
                        <td *ngIf="performanceTwo?.fuel_type == 'EV' || performanceTwo?.fuel_type == 'Electric'">
                          {{ performanceTwo && performanceTwo.max_motor_power ? performanceTwo.max_motor_power : "-" }}
                        </td>
                        <td *ngIf="performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric'">
                          {{ performanceTwo && performanceTwo.max_power ? performanceTwo.max_power : "-" }}
                        </td>
                        <td *ngIf="!performanceThree">-</td>

                        <td
                          *ngIf="performanceThree && (performanceTwo?.fuel_type == 'EV' || performanceTwo?.fuel_type == 'Electric') ">
                          {{
                          performanceThree && performanceThree.max_motor_power ? performanceThree.max_motor_power : "-"
                          }}
                        </td>
                        <td
                          *ngIf="performanceThree && (performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')">
                          {{
                          performanceThree && performanceThree.max_power ? performanceThree.max_power : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Max Torque</td>
                        <td>
                          {{ performanceOne && performanceOne.max_torque ? performanceOne.max_torque : "-" }}
                        </td>
                        <td>
                          {{ performanceTwo && performanceTwo.max_torque ? performanceTwo.max_torque : "-" }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.max_torque ? performanceThree.max_torque : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Emission Norms</td>
                        <td>
                          {{
                          performanceOne && performanceOne.emission_norms
                          ? performanceOne.emission_norms
                          : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceTwo && performanceTwo.emission_norms
                          ? performanceTwo.emission_norms
                          : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.emission_norms
                          ? performanceThree.emission_norms
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                          <td
                          *ngIf="(!performanceOne && !performanceTwo && !performanceThree)">
                          Engine Type</td>
                          <td
                          *ngIf="(performanceOne || performanceTwo || performanceThree) && (performanceOne.fuel_type == 'EV' || performanceTwo?.fuel_type == 'EV' || performanceThree?.fuel_type == 'EV' || performanceOne?.fuel_type == 'Electric' || performanceTwo?.fuel_type == 'Electric' || performanceThree?.fuel_type == 'Electric')">
                          Engine Type / Motor Type</td>
                          <td
                          *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && !performanceTwo && !performanceThree)">
                          Engine Type</td>
                          <td
                          *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo && performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && !performanceThree">
                          Engine Type</td>

                        <td
                          *ngIf="((performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && performanceThree && (performanceThree?.fuel_type != 'EV' && performanceThree?.fuel_type != 'Electric')">
                          Engine Type</td>
                        <td *ngIf="performanceOne?.fuel_type == 'EV'">
                          {{ performanceOne && performanceOne.motor ? performanceOne.motor : "-" }}
                        </td>
                        <td *ngIf="(performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric')">
                          {{ performanceOne && performanceOne.engine_type ? performanceOne.engine_type : "-" }}
                        </td>

                        <td *ngIf="(performanceTwo?.fuel_type == 'EV' || performanceTwo?.fuel_type == 'Electric')">
                          {{ performanceTwo && performanceTwo.motor ? performanceTwo.motor : "-" }}
                        </td>
                        <td *ngIf="(performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')">
                          {{ performanceTwo && performanceTwo.engine_type ? performanceTwo.engine_type : "-" }}
                        </td>
                        <td
                          *ngIf="performanceThree && (performanceThree?.fuel_type == 'EV' || performanceThree?.fuel_type == 'Electric')">
                          {{
                          performanceThree && performanceThree.motor
                          ? performanceThree.motor
                          : "-"
                          }}
                        </td>
                        <td
                          *ngIf="!performanceThree">
                          -
                        </td>
                        <td
                          *ngIf="performanceThree && (performanceThree?.fuel_type != 'EV' && performanceThree?.fuel_type != 'Electric')">
                          {{
                          performanceThree && performanceThree.engine_type
                          ? performanceThree.engine_type
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Engine Cylinders</td>
                        <td>
                          {{
                          performanceOne && performanceOne.engine_cylinders
                          ? performanceOne.engine_cylinders
                          : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceTwo && performanceTwo.engine_cylinders
                          ? performanceTwo.engine_cylinders
                          : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.engine_cylinders
                          ? performanceThree.engine_cylinders
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Gradeability</td>
                        <td>
                          {{
                          performanceOne && performanceOne.gradeability ? performanceOne.gradeability : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceTwo && performanceTwo.gradeability ? performanceTwo.gradeability : "-"
                          }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.gradeability
                          ? performanceThree.gradeability
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                        *ngIf="(!performanceOne && !performanceTwo && !performanceThree)">
                        Fuel Tank Capacity (Litres)</td>
                        <td
                          *ngIf="(performanceOne || performanceTwo || performanceThree) && (performanceOne.fuel_type == 'EV' || performanceTwo?.fuel_type == 'EV' || performanceThree?.fuel_type == 'EV' || performanceOne?.fuel_type == 'Electric' || performanceTwo?.fuel_type == 'Electric' || performanceThree?.fuel_type == 'Electric')">
                          Fuel Tank Capacity (Litres) / Battery Capacity (kWh)</td>
                          <td
                          *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && !performanceTwo && !performanceThree)">
                          Fuel Tank Capacity (Litres)aa</td>
                          <td
                          *ngIf="((performanceOne && performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo && performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && !performanceThree">
                          Fuel Tank Capacity (Litres)</td>

                        <td
                          *ngIf="((performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric') && (performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')) && performanceThree && (performanceThree?.fuel_type != 'EV' && performanceThree?.fuel_type != 'Electric')">
                          Fuel Tank Capacity (Litres)a</td>


                        <td *ngIf="(performanceOne?.fuel_type == 'EV' || performanceOne?.fuel_type == 'Electric')">
                          {{
                          performanceOne && performanceOne.battery_capacity
                          ? performanceOne.battery_capacity
                          : "-"
                          }}
                        </td>
                        <td *ngIf="(performanceOne?.fuel_type != 'EV' && performanceOne?.fuel_type != 'Electric')">
                          {{
                          performanceOne && performanceOne.fuel_tank_capacity
                          ? performanceOne.fuel_tank_capacity
                          : "-"
                          }}
                        </td>
                        <td *ngIf="(performanceTwo?.fuel_type != 'EV' && performanceTwo?.fuel_type != 'Electric')">
                          {{
                          performanceTwo && performanceTwo.fuel_tank_capacity
                          ? performanceTwo.fuel_tank_capacity
                          : "-"
                          }}
                        </td>
                        <td *ngIf="(performanceTwo?.fuel_type == 'EV' || performanceTwo?.fuel_type == 'Electric')">
                          {{
                          performanceTwo && performanceTwo.battery_capacity
                          ? performanceTwo.battery_capacity
                          : "-"
                          }}
                        </td>
                        <td
                          *ngIf="performanceThree && (performanceThree?.fuel_type != 'EV' &&  performanceThree?.fuel_type != 'Electric')">
                          {{
                          performanceThree && performanceThree.fuel_tank_capacity
                          ? performanceThree.fuel_tank_capacity
                          : "-"
                          }}
                        </td>
                        <td
                        *ngIf="!performanceThree">-</td>
                        <td
                          *ngIf="performanceThree && (performanceThree?.fuel_type == 'EV' ||  performanceThree?.fuel_type == 'Electric')">
                          {{
                          performanceThree && performanceThree.battery_capacity
                          ? performanceThree.battery_capacity
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Fuel Type</td>
                        <td>
                          {{ performanceOne && performanceOne.fuel_type ? performanceOne.fuel_type : "-" }}
                        </td>
                        <td>
                          {{ performanceTwo && performanceTwo.fuel_type ? performanceTwo.fuel_type : "-" }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.fuel_type ? performanceThree.fuel_type : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Clutch Type</td>
                        <td>
                          {{ performanceOne && performanceOne.clutch_type ? performanceOne.clutch_type : "-" }}
                        </td>
                        <td>
                          {{ performanceTwo && performanceTwo.clutch_type ? performanceTwo.clutch_type : "-" }}
                        </td>
                        <td>
                          {{
                          performanceThree && performanceThree.clutch_type
                          ? performanceThree.clutch_type
                          : "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Gear Box</td>
                        <td>
                          {{ performanceOne && performanceOne.gearbox ? performanceOne.gearbox : "-" }}
                        </td>
                        <td>
                          {{ performanceTwo && performanceTwo.gearbox ? performanceTwo.gearbox : "-" }}
                        </td>
                        <td>
                          {{ performanceThree && performanceThree.gearbox ? performanceThree.gearbox : "-" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  <img [src]='environment1 + "assets/images/design-build.png"' alt="design-build" class="img-fluid" loading="lazy"/> Design & Build
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <table class="table">
                    <tbody>
                        <tr>
                          <td>GVW / GCW (Kgs)</td>
                          <td>
                            {{ performanceOne && performanceOne.gvw ? performanceOne.gvw : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.gvw ? performanceTwo.gvw : "-" }}
                          </td>
                          <td>
                            {{ performanceThree && performanceThree.gvw ? performanceThree.gvw : "-" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Kerb Weight</td>
                          <td>
                            {{ performanceOne && performanceOne.kerb_weight ? performanceOne.kerb_weight : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.kerb_weight ? performanceTwo.kerb_weight : "-" }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.kerb_weight
                            ? performanceThree.kerb_weight
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Wheelbase (mm)</td>
                          <td>
                            {{ performanceOne && performanceOne.wheelbase ? performanceOne.wheelbase : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.wheelbase ? performanceTwo.wheelbase : "-" }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.wheelbase ? performanceThree.wheelbase : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Overall Width (mm)</td>
                          <td>
                            {{ performanceOne && performanceOne.width ? performanceOne.width : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.width ? performanceTwo.width : "-" }}
                          </td>
                          <td>
                            {{ performanceThree && performanceThree.width ? performanceThree.width : "-" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Overall Height (mm)</td>
                          <td>
                            {{ performanceOne && performanceOne.height ? performanceOne.height : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.height ? performanceTwo.height : "-" }}
                          </td>
                          <td>
                            {{ performanceThree && performanceThree.height ? performanceThree.height : "-" }}
                          </td>
                        </tr>
                        <tr>
                          <td>CABIN TYPE (FIXED/TILTABLE)</td>
                          <td>
                            {{ performanceOne && performanceOne.cabin_type ? performanceOne.cabin_type : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.cabin_type ? performanceTwo.cabin_type : "-" }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.cabin_type ? performanceThree.cabin_type : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>CABIN TYPE (Day/Sleeper)</td>
                          <td>
                            {{
                            performanceOne && performanceOne.cabin_type_day
                            ? performanceOne.cabin_type_day
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceTwo && performanceTwo.cabin_type_day
                            ? performanceTwo.cabin_type_day
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.cabin_type_day
                            ? performanceThree.cabin_type_day
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Body Option</td>
                          <td>
                            {{ performanceOne && performanceOne.body_option ? performanceOne.body_option : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.body_option ? performanceTwo.body_option : "-" }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.body_option
                            ? performanceThree.body_option
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Load Body Length</td>
                          <td>
                            {{
                            performanceOne && performanceOne.load_body_length
                            ? performanceOne.load_body_length
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceTwo && performanceTwo.load_body_length
                            ? performanceTwo.load_body_length
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.load_body_length
                            ? performanceThree.load_body_length
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Load Body Type</td>
                          <td>
                            {{
                            performanceOne && performanceOne.load_body_type
                            ? performanceOne.load_body_type
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceTwo && performanceTwo.load_body_type
                            ? performanceTwo.load_body_type
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.load_body_type
                            ? performanceThree.load_body_type
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Seating Capacity & Layout</td>
                          <td>
                            {{
                            performanceOne && performanceOne.seating_capacity_layout
                            ? performanceOne.seating_capacity_layout
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceTwo && performanceTwo.seating_capacity_layout
                            ? performanceTwo.seating_capacity_layout
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.seating_capacity_layout
                            ? performanceThree.seating_capacity_layout
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Passenger Door</td>
                          <td>
                            {{
                            performanceOne && performanceOne.passenger_door
                            ? performanceOne.passenger_door
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceTwo && performanceTwo.passenger_door
                            ? performanceTwo.passenger_door
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.passenger_door
                            ? performanceThree.passenger_door
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Side Windows</td>
                          <td>
                            {{
                            performanceOne && performanceOne.side_windows ? performanceOne.side_windows : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceTwo && performanceTwo.side_windows ? performanceTwo.side_windows : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.side_windows
                            ? performanceThree.side_windows
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Hat-rack</td>
                          <td>
                            {{ performanceOne && performanceOne.hat_rack ? performanceOne.hat_rack : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.hat_rack ? performanceTwo.hat_rack : "-" }}
                          </td>
                          <td>
                            {{ performanceThree && performanceThree.hat_rack ? performanceThree.hat_rack : "-" }}
                          </td>
                        </tr>
                        <tr>
                          <td>Axle Configuration</td>
                          <td>
                            {{
                            performanceOne && performanceOne.axle_configuration
                            ? performanceOne.axle_configuration
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceTwo && performanceTwo.axle_configuration
                            ? performanceTwo.axle_configuration
                            : "-"
                            }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.axle_configuration
                            ? performanceThree.axle_configuration
                            : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>No. of Wheels</td>
                          <td>
                            {{ performanceOne && performanceOne.no_wheels ? performanceOne.no_wheels : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.no_wheels ? performanceTwo.no_wheels : "-" }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.no_wheels ? performanceThree.no_wheels : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Front Tyre</td>
                          <td>
                            {{ performanceOne && performanceOne.front_tyre ? performanceOne.front_tyre : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.front_tyre ? performanceTwo.front_tyre : "-" }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.front_tyre ? performanceThree.front_tyre : "-"
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>Rear Tyre</td>
                          <td>
                            {{ performanceOne && performanceOne.rear_tyre ? performanceOne.rear_tyre : "-" }}
                          </td>
                          <td>
                            {{ performanceTwo && performanceTwo.rear_tyre ? performanceTwo.rear_tyre : "-" }}
                          </td>
                          <td>
                            {{
                            performanceThree && performanceThree.rear_tyre ? performanceThree.rear_tyre : "-"
                            }}
                          </td>
                        </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
